export * from './getBlogPost'
export * from './getBlogPosts'
export * from './getLegalDocument'
export * from './getBlogPostBySlug'